import React, { useMemo } from "react";

import { faCheckCircle, faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnType } from "antd/es/table";
import Tag from "antd/es/tag";
import { FormattedMessage, IntlShape } from "react-intl";

import IntegrationFieldResponse from "@app/types/integrations/IntegrationFieldResponse";

const useResultColumnConfig = (intl: IntlShape): ColumnType<IntegrationFieldResponse>[] =>
  useMemo(
    () => [
      {
        dataIndex: "mmcDisplayName",
        title: intl.formatMessage({
          id: "integrations.finalizeStep.column.mmcDisplayName",
          defaultMessage: "Name",
          description: "Title of a mmcDisplayName field",
        }),
      },
      {
        dataIndex: "mmcDataType",
        title: intl.formatMessage({
          id: "integrations.finalizeStep.column.mmcDataType",
          defaultMessage: "Data Type",
          description: "Title of a mmcDataType field",
        }),
      },
      {
        dataIndex: "errored",
        render: (errored) => (
          <Tag color={errored ? "error" : "success"}>
            <FormattedMessage
              id="integrations.finalizeStep.column.status.text"
              defaultMessage="{icon} {errored, select, true {Not Created} other {Created}}"
              description="Text of status message"
              values={{
                errored,
                icon: <FontAwesomeIcon icon={errored ? faInfoCircle : faCheckCircle} />,
              }}
            />
          </Tag>
        ),
        title: intl.formatMessage({
          id: "integrations.finalizeStep.column.status",
          defaultMessage: "Status",
          description: "Title of a status field",
        }),
      },
    ],
    [intl]
  );

export default useResultColumnConfig;
